var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-wrapper",class:{'full-page' : _vm.fullPage}},[(_vm.fullPage)?_c('div',{staticClass:"shadow"}):_vm._e(),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle"},[_c('div',{staticClass:"center-circle"},[_c('div',{staticClass:"satellite-circle"})])])
}]

export { render, staticRenderFns }